export const module = {
  herder: {
    title1: "Home",
    title2: "Task",
    title3: "Integral",
    title4: "Activity",
    title5: "Help",
  },
  navigation: {
    title1: "My Home",
    title2: "Task list",
    title3: "Exchange",
    title4: "Gold coins",
    title5: "Account",
    title6: "My Invite",
    title7: "Credit value",
  },
  notice: {
    title1: "Notice",
    title2: "Clear All",
    title3: "Set as read",
    title4: "Delete",
  },
  homepage: {
    title1: "Grade",
    title2: "Sign in",
    title3: "The next level still requires",
    title4: "My coins",
    title5: "Credit value",
    title6: "Reward coefficient",
    title7: "View details",
    title8: "Task list",
    title9: "View more",
    title10: "Use",
    title11: "Gold coins",
    title12: "minute",
    title13: "hide",
    title14: "Participate in",
    title15: "Received",
    title16: "Day",
    title17: "",
    title18: "Unclaimed",
    title19: "Continuous check-in",
    title20: "Check in today",
    title21: "Day",
    signing: "Signing in",
    signed: "Signed in",
    noData: "No Data",
    multipleCompletion: "Multiple Completion",
    participateNow: "Participate Now",
    todaySigned: "Today Signed In",
    sunday: "Sun",
    monday: "Mon",
    tuesday: "Tue",
    wednesday: "Wed",
    thursday: "Thu",
    friday: "Fri",
    saturday: "Sat",
    fiveStarAlt: "Five Star",
    placeholderText: "This is content This is content This is content This is content This is content This is content This is content This is content",
    imageAlt: "Image"
  },
  taskRecord: {
    title1: "Participation time",
    title2: "Start date",
    title3: "To",
    title4: "End date",
    title5: "Participation status",
    title6: "Please select",
    title7: "Review status",
    title8: "screen",
    title9: "Questionnaire number",
    title10: "Questionnaire name",
    title11: "Participation time",
    title12: "Gold coin rewards",
    title13: "Participation status",
    title14: "Review status",
    title15: "Questionnaire number or name",
  },
  redemptionHistory: {
    title1: "Redemption History",
    title2: "Order number",
    title3: "Prize Name",
    title4: "Transaction time",
    title5: "Consumption coins",
    title6: "Order status",
    title7: "Order remarks",
  },
  goldHistory: {
    title1: "Gold coin balance",
    title2: "Freeze amount",
    title3: "Accumulated income",
    title4: "Accumulated expenses",
    title5: "Participation time",
    title6: "Start date",
    title7: "To",
    title8: "End date",
    title9: "Review status",
    title10: "Please select",
    title11: "Screen",
    title12: "Name",
    title13: "Time",
    title14: "Gold coins",
    title15: "Gold coin details",
    title16: "Change year",
    title17: "Select year",
    title18: "Change type",
    title19: "Points type",
    title20: "Load more",
    title21: "No more data~",
    title22: "No data",
    title23: "Change time",
    title24: "Change amount",
    title25: "Description",
    title26: "Income",
    title27: "Expense",
    title28: "Questionnaire status",
  },
  account: {
    title1: "Basic information",
    title2: "Data completeness",
    title3: "Improving information can increase credit value by 10",
    title4: "personal information",
    title5: "Account management",
    title6: "Name",
    title7: "Gender",
    title8: "Date of Birth",
    title9: "Province",
    title10: "City",
    title11: "District/County",
    title12: "Position",
    title13: "Personal monthly salary",
    title14: "Family monthly income",
    title15: "Private cars",
    title16: "Do you have any children",
    title17: "preserve",
    title18: "Change nickname",
    title19: "Only modified once a month",
    title20: "Modify",
    title21: "Mobile phone number",
    title22:
      "Please enter your commonly used mobile phone number. Once verified, modifications will not be allowed. If you have changed your phone number, please contact customer service.",
    title23: "Password",
    title24: "Regularly changing passwords is beneficial for account security",
    title25: "WeChat",
    title26: "Unbound",
    title27: "Unbind",
    title28: "Third party binding for quick login",
    title29: "Alipay",
    title30: "Bound",
    title31: "Account settings",
    title32: "Please enter",
    title33: "Please select",
    title34: "Marital Status",
    title35: "Education",
    title36: "Work Status",
    title37: "Personal Monthly Income",
    title38: "Family Monthly Income",
    title39: "Position",
    title40: "Do you have children",
    title41: "Gender of youngest child",
    title42: "Birth year of youngest child",
    title43: "Car Brand",
    title44: "Car Model",
    title45: "Year of car purchase",
    title46: "Personal diseases",
    title47: "Family member diseases",
    title48: "Alipay Account",
    title49: "Unbound",
    title50: "Bind",
    title51: "Alipay account binding, once submitted it is confirmed and cannot be modified",
    title52: "Mobile verification is mainly for real-name authentication during exchange to protect your account security.",
    title53: "Please enter your commonly used mobile phone number. Once verified, modifications will not be allowed. If you have changed your phone number, please contact customer service.",
    title54: "Change Avatar",
    title55: "Change Password",
    title56: "Old Password",
    title57: "New Password",
    title58: "Confirm Password",
    title59: "Cancel",
    title60: "Confirm",
    title61: "Only modifiable for the first time",
    title62: "Third-party account binding",
    title63: "Male",
    title64: "Female",
    title65: "Yes",
    title66: "No",
    title67: "Date of Birth",
    title68: "Please enter",
  },
  invite: {
    title1: "Friend invitation",
    title2: "Method 1: Share Link",
    title3:
      "Copy the link to a friend, who can register as a member through this link and successfully invite them",
    title4: "One click copy",
    title5: "Method 2: Download QR code",
    title6: "Click to download",
    title7: "My invitation",
    title8: "People",
    title9: "Invited",
    title10: "Yuan",
    title11: "Obtained",
    title12: "Please enter your friend's account",
    title13: "Friend account",
    title14: "Registration time",
    title15: "Make it for me",
    title16: "Scrap rate",
    title17: "Activity rules",
    title18:
      "1. Invite friends to register for AliExpress through promotional links, QR codes, and WeChat Weibo.",
    title19:
      "2. The first time your friend completes a survey, you will immediately receive a one-time 2 yuan referral reward (including: K survey, Y survey, G survey, P survey (excluding S survey)). At the same time, for every survey completed by your friend in the future, you can receive a 20% commission. For example, if you recommend your friend 'Xiao Diao' to register for 'Quick Tune Bar', and 'Xiao Diao' completes a 30 yuan survey for the first time, you can receive a 2 yuan recommendation reward+6 yuan commission reward.",
    title20:
      "3. If your friend has not participated in any surveys for more than 6 months, in order to avoid idle resources, the account will be considered a dormant user and will disconnect from you as a friend, and you will not be able to receive rewards.",
    title21:
      "4. Event Date: January 1, 2023 to December 31, 2023. Attention: Rewards will double during the event period, and will return to normal after the event ends.",
  },
  credit: {
    title1: "Grade",
    title2: "Understand the upgrade rules",
    title3: "Not even close to the next level",
    title4: "Credit",
    title5: "Credit details",
    title6: "Revenue enhancement",
    title7: "Current class interest",
    title8: "Credit accumulation rules",
    title9: "1. General :≤60, V1 member, can have a 30-day protection card;",
    title10:
      "2. Medium :61≤ credit value ≤100, V2 members can have an additional 5% reward card, 1 Golden Shield protection card;",
    title11:
      "3. Good :101≤ credit value ≤200, V3 member, can have additional reward card 10%, 1 Golden Shield protection card, VIP fast review channel;",
    title12:
      "4. Excellent :201≤ credit value ≤500, V4 members, can have additional reward card 15%, 1 Golden Shield protection card, VIP fast review channel;",
    title13:
      "5. Diamond :501≤ credit value ≤800, V5 members can have an additional 20% reward card, 1 Golden Shield protection card, VIP fast review channel; ",
    title14:
      "6. King :801≤ credit value ≤1000, for V6 members, can have an additional reward card 40%, 1 Golden Shield protection card, VIP fast review channel; ",
    title15: "Remark",
    title16:
      "1. If you do not participate in any questionnaire for 6 consecutive months, your credit will be cleared to zero.",
    title17:
      "2. Double reward card issuance rules. On the 5th day of each month, the system will calculate the number of double cards according to your current credit value, and randomly double the projects you completed and approved last month. Special note: If the current credit value is greater than 801, you get 4 doubled cards, but only completed and approved 2 business questionnaires last month, then you can only double 2 business questionnaire rewards, and the remaining 2 doubled cards are invalidated. Event Date (May 1, 2023 - September 30, 2023)",
    title18:
      "3. For the purpose of the Golden Shield protection card, after the credit value is greater than the initial value of 60, no gold coins will be deducted for the questionnaire that fails to pass the examination of the answer paper.",
    title19:
      "4.VIP Fast Review Channel card is only for wechat red envelope orders, and Alipay orders are uniformly reviewed and issued every Friday.",
    title20:
      "5. The credit system will be adjusted according to the actual situation.",
    title21:
      "6. Welfare card includes 'double card', 'increase card', 'protection card', 'audit card', 'lottery card'. The specific issued cards and the corresponding number are related to the credit value at the time, and shall be subject to the actual issuance.",
    title22:
      "7. Those who obtain credit through improper means will be punished, and in serious cases, their accounts will be deleted.",
    title23:
      "8. At present, credit value audit is only conducted for business investigations, except K questionnaire,Y questionnaire, Lucky questionnaire,G questionnaire and S questionnaire.",
    title24:
      "9. After the credit value is lower than the initial value of 60, Alipay and wechat exchange orders will enter the manual review stage, and the order review will be carried out after the completion of the review. The general time range is 1-4 weeks.",
    title25:
      "Take you to learn more survey tips and unlock more level benefits",
    title26: "Current level score",
    title27: "distance",
    title28: "grade",
    title29: "Still lacking",
    title30: "Credit value",
    title31: "Level V6",
    title32: "30-day protection card",
    title33: "First registration",
    title34: "Extra reward 5%",
    title35: "Extra reward 10%",
    title36: "Extra reward 15%",
    title37: "Extra reward 20%",
    title38: "Extra reward 40%",
    title39: "Complete task",
    title40: "Golden shield protection card",
    title41: "VIP fast review channel",
    title42: "Iron",
    title43: "Bronze",
    title44: "Silver",
    title45: "Gold",
    title46: "Diamond",
    title47: "King",
    title48: "Member",
    title49: "General",
    title50: "Medium",
    title51: "Good",
    title52: "Excellent",
    title53: "Increase",
    title54: "Deduct",
    title55: "Load more",
    title56: "No more data~",
    title57: "No data",
    title58: "Credit history",
    title59: "Return to previous",
    title60: "Occurrence time",
    title61: "Credit value",
    title62: "Status",
    title63: "Credit description",
    title64: "Completed",
    title65: "Incomplete",
    title66: "Other",
    title67: "Reviewed",
    title68: "Pending review",
  },
  exchange: {
    title1: "Exchange",
    title2: "Cash category",
    title3: "Coupons category",
    title4: "Gift category",
    title5: "Gold",
    title6: "surplus",
    title7: "pcs",
    title8: "Immediate exchange",
    title9: "Gold coins can be exchanged for cash",
    title10: "No data",
    title11: "10 yuan voucher",
    title12: "10 yuan phone card",
    title13: "Tips",
    title14: "Please confirm your Alipay account and name:",
    title15: "Alipay account:",
    title16: "Alipay account: Not filled in",
    title17: "Name:",
    title18: "Not filled in",
    title19: "Cancel",
    title20: "Update Alipay",
    title21: "I have confirmed the exchange account, exchange now",
    title22: "This prize is out of stock, please wait patiently for the admin to restock!",
    title23: "Exchange successful",
  },
  activity: {
    title1: "Popular activities",
    title2: "Task rewards",
    title3: "Gold",
    title4: "Participate in",
    title5: "Previous events",
  },

  commerce: {
    title1: "Business cooperation",
    title2: "If needed, please contact us by phone",
    title3: "Welcome to cooperate",
    title4: "Contact information",
    title5: "market research",
    title6: "cooperation or shunt",
    title7: "Member Recruitment ",
  },
  taskD: {
    title1: "Daily tasks",
    title2: "Name",
    title3: "Computer only answer questions",
    title4: "Gold available",
    title5: "Gold",
    title6: "Reward method",
    title7: "Real time rewards",
    title8: "Duration",
    title9: "about",
    title10: "minute",
    title11: "Questionnaire requirements",
    title12:
      " 1. Please answer the questions carefully and carefully, maintain the rationality of the answers, and avoid linear answering situations, otherwise it will be invalidated and affect your credit value. Thank you for your cooperation<br/> 2. In the later inspection, unqualified data will be removed and credit values will be deducted<br/> 3. If there is duplicate and identical data, it will be banned. Thank you for your participation!",
    title13: "Answering ",
    title14: "Thoughtful tips",
    title15:
      "1. When answering the questionnaire, do not interrupt as you may not be able to obtain coins<br/>2。 Do not click the return button when answering questions<br/> 3. Some questionnaires are loading slowly, please wait.",
      title16:'Passing rate'
  },
};
